module.exports = __webpack_public_path__ + "static/bona_fide_masks-6da57f6862b356f4243bdf2860e4777d.png";